<app-link
  class="link"
  color="red"
  [pseudo]="true"
  [displayText]="'components.deleteAuthUserLink.buttons.deleteAuthUser' | translate"
  (click)="onClickDeleteButton()"
></app-link>
